// @ts-nocheck
import * as yup from 'yup'
import { StringSchema } from 'yup'
import { createProxyDecorator } from './utils'

export function string(): StringSchema {
  const schema = yup.string()

  return createProxyDecorator(schema)
}
